export default __webpack_public_path__ + "static/media/986.06b6f2f3.png";